import {createSubmitRequestTypes} from "./helpers";

export const REQUEST_CANCEL_SALES_ORDER = "SALES:REQUEST_CANCEL_SALES_ORDER";
export const CANCEL_SALES_ORDER = createSubmitRequestTypes("SALES:CANCEL_SALES_ORDER");
export const requestCancelSalesOrder = (id) => ({ type: REQUEST_CANCEL_SALES_ORDER, id });
export const cancelCancelSalesOrder = () => ({ type: CANCEL_SALES_ORDER.CANCEL });

export const REQUEST_CREATE_PROMO_CODE = "SALES:REQUEST_CREATE_PROMO_CODE";
export const CREATE_PROMO_CODE = createSubmitRequestTypes("SALES:CREATE_PROMO_CODE");
export const requestCreatePromoCode = (id) => ({ type: REQUEST_CREATE_PROMO_CODE, id });
export const cancelCreatePromoCode = () => ({ type: CREATE_PROMO_CODE.CANCEL });

export const REQUEST_EDIT_PROMO_CODE = "SALES:REQUEST_EDIT_PROMO_CODE";
export const EDIT_PROMO_CODE = createSubmitRequestTypes("SALES:EDIT_PROMO_CODE");
export const requestEditPromoCode = (code) => ({ type: REQUEST_EDIT_PROMO_CODE, code });
export const cancelEditPromoCode = () => ({ type: EDIT_PROMO_CODE.CANCEL });

export const REQUEST_VOID_CHARGE = "SALES:REQUEST_VOID_CHARGE";
export const VOID_CHARGE = createSubmitRequestTypes("SALES:VOID_CHARGE");
export const requestVoidCharge = (salesOrderId) => ({ type: REQUEST_VOID_CHARGE, salesOrderId });
export const cancelVoidCharge = () => ({ type: VOID_CHARGE.CANCEL });

export const REQUEST_CREATE_REFERRAL_CODE = "SALES:REQUEST_CREATE_REFERRAL_CODE";
export const CREATE_REFERRAL_CODE = createSubmitRequestTypes("SALES:CREATE_REFERRAL_CODE");
export const requestCreateReferralCode = () => ({ type: REQUEST_CREATE_REFERRAL_CODE });
export const cancelCreateReferralCode = () => ({ type: CREATE_REFERRAL_CODE.CANCEL });

export const REQUEST_EDIT_REFERRAL_CODE = "SALES:REQUEST_EDIT_REFERRAL_CODE";
export const EDIT_REFERRAL_CODE = createSubmitRequestTypes("SALES:EDIT_REFERRAL_CODE");
export const requestEditReferralCode = (code) => ({ type: REQUEST_EDIT_REFERRAL_CODE, code });
export const cancelEditReferralCode = () => ({ type: EDIT_REFERRAL_CODE.CANCEL });

export const REQUEST_VIEW_META_ORDER_HISTORY = "SALES:REQUEST_VIEW_META_ORDER_HISTORY";
export const VIEW_META_ORDER_HISTORY = createSubmitRequestTypes("SALES:VIEW_META_ORDER_HISTORY");
export const requestViewMetaOrderHistory = (metaOrderId) => ({ type: REQUEST_VIEW_META_ORDER_HISTORY, metaOrderId });
export const cancelViewMetaOrderHistory = () => ({ type: VIEW_META_ORDER_HISTORY.CANCEL });

